import { socialApiClient } from '@/shared/api-client/social-api-client';
import { HTTPError } from 'ky';
import type { USER_ROLE } from '../user/constants';
import type { GetWorkspaceUsageResponse, Workspace, WorkspaceSettingPayload } from './types';

export const fetchWorkspace = async (workspaceId: string): Promise<Workspace> => {
  const response = await socialApiClient.get(`workspaces/${workspaceId}`);
  return response.json();
};

export const fetchWorkspaceUsage = async (
  workspaceId: string,
): Promise<GetWorkspaceUsageResponse> => {
  const response = await socialApiClient.get(`workspaces/${workspaceId}/usage`);
  return response.json();
};

/**
 * Check if a workspace name already exists
 */
export async function checkWorkspaceNameExists({ name }: { name: string }): Promise<{
  exists: boolean;
}> {
  const response = await socialApiClient.post('workspaces/exists', {
    json: { name },
  });

  return response.json<{
    exists: boolean;
  }>();
}

export async function updateWorkspaceSettings(
  workspaceId: string,
  payload: WorkspaceSettingPayload,
): Promise<Workspace> {
  const response = await socialApiClient.patch<Workspace>(`workspaces/${workspaceId}`, {
    json: payload,
  });

  return response.json();
}

export const getInviteCode = async (
  workspaceId: string,
  type: USER_ROLE,
): Promise<{
  code: string;
} | null> => {
  try {
    const response = await socialApiClient.get(`workspaces/${workspaceId}/invite_code`, {
      searchParams: {
        type,
      },
    });
    if (response.status === 204) return null;
    return response.json();
  } catch (e) {
    if (e instanceof HTTPError && e.response.status === 404) return null;
    throw e;
  }
};

export const generateInviteCode = async (workspaceId: string, type: USER_ROLE): Promise<string> => {
  const response = await socialApiClient.post(`workspaces/${workspaceId}/invite_code`, {
    searchParams: {
      type,
    },
  });
  return response.json();
};
